<template>
    <popup :show="true" width="640px" @on-close="onClose">
        <div class="move-file">
            <div class="move-file-container">
                <div class="move-file-title">加入团队资源库</div>
                <div class="move-file-desc">{{teamName}}<span>所有者</span></div>
                <div class="folder-list">
                    <folder-tree 
                        :folders="processFolders"
                        :level="0"
                        :selectedFolder="curr_folder"
                        :parentFolder="folderId"
                        @select-folder="onFolderClick"
                    />
                </div>
            </div>
            <div class="btn-box">
                <div class="btn" @click="onClose">取消</div>
                <div class="btn" @click="onConfirimMove">确定</div>
            </div>
        </div>
    </popup>
</template>
<script> 
import { teamFileCreate, teamFolderFileList } from '@/api/index';
import Popup from "@/components/Popup";
import FolderTree from './FolderTree.vue';
export default{
    name:"MoveFile",
    components:{
        Popup,
        FolderTree
    },
    props:{
        teamId:{
            type:String,
            default:''
        },
        rootFolderType:{
            type:Number,
            default:0
        },
        file:{
            type:Object,
            default:()=>({})
        },
        teamName:{
            type:String,
            default:''
        }
    },
    computed:{
        folderId(){
            console.log('folders',this.folders[0]);
            if(!this.folders.length) return '';
            return this.folders[0].uuid;
        },
        processFolders(){
            return this.folders.map((item)=>{return {...item,expanded:false}})
        }
    },
    data(){
        return{
            folders:[],
            curr_folder:{}
        }
    },
    mounted(){
        this.onGetFolderList(true);
    },
    methods:{
        async onGetFolderList(init=false){
            try{
                const param = {};
                param.team_uuid = this.teamId;
                param.parent_directory_uuid = init ?'':this.curr_folder.uuid;
                const {code,msg,data} = await teamFolderFileList(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;                
                }
                console.log('data-folders',data.filter(item=>item.is_dir && item.type == 1));
                if(init){
                    this.folders = data.filter(item=>item.is_dir && item.type == this.rootFolderType);
                }else{
                    this.folders = data.filter(item=>item.is_dir && (item.type == 1));
                }
            }catch(e){
                console.log('err-get-folder-list-move',e);
                this.$layer.msg(e.msg);
            }
        },
        async onConfirimMove(){
            try{
                console.log('on-confirm-move',this.curr_folder);
                console.log('file',this.file);
                // return;
                let type;
                switch(this.rootFolderType){
                    case 1:
                        type = '51';
                        break;
                    case 2:
                        type = '52';
                        break;
                    case 3:
                        type = '53';
                        break;
                }
                const param = {};
                param.team_uuid = this.teamId;
                param.directory_uuid = this.curr_folder.uuid;
                param.type = type;
                let info = {};
                if(this.rootFolderType == 1){
                    const {
                        pattern_number,
                        pattern_id,
                        pattern,
                        first_product_category_id,
                        second_product_category_id,
                        product_category_id,
                        sex,
                        consumption,
                        consumption2,
                        pattern_type,
                        main_image
                    } = this.file;
                    const {guige_name,guige_path} = pattern;
                    console.log('...==>pattern_number',pattern_number,'pattern_name',pattern.name);
                    switch(Number(pattern_type)){
                        case 1:
                            info.name = pattern_number || pattern.name || pattern[0].name;
                            info.pattern_id = pattern_id;
                            info.pattern_type = pattern_type;
                            info.first_product_category_id = first_product_category_id;
                            info.second_product_category_id = second_product_category_id;
                            info.product_category_id = product_category_id;
                            info.sex = sex;
                            info.consumption = consumption;
                            info.consumption2 = consumption2;
                            info.guige_name = guige_name;
                            info.guige_path = guige_path;
                            info.image = main_image;
                            break;
                        case 2:
                            info.name = guige_name || pattern.name || `未命名-${new Date().getTime()}`;
                            info.guige_name = guige_name;
                            info.guige_path = guige_path;
                            info.consumption = consumption;
                            info.consumption2 = consumption2;
                            info.sex = sex;
                            info.image = main_image;
                            info.pattern_type = pattern_type;
                            break;
                        case 3:
                            info.name = pattern.name || pattern[0].name || `未命名-${new Date().getTime()}`;
                            info.difficulty = pattern.difficulty || pattern[0].difficulty;
                            info.pattern_type = pattern_type;
                            info.c_content = pattern.c_content || pattern[0].c_content;
                            info.c_scene = pattern.c_scene || pattern[0].c_scene;
                            info.c_type = pattern.c_type || pattern[0].c_type;
                            info.sex = pattern.sex || pattern[0].sex;
                            info.path = pattern.path || pattern[0].path;
                            break;
                    }
                }else{
                    info = this.file;
                }
                param.info = info;
                console.log('param-move-file',param);
                const {code,msg} = await teamFileCreate(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$emit('on-move-success');
                this.onClose();
            }catch(e){
                console.log('err-move-file',e);
                this.$layer.msg(e.msg);
            }
        },
        onFolderClick(e){
            console.log('folder-click',e);
            this.curr_folder = {...e};
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .move-file{
        width:100%;
        background:#ffffff;
        border-radius:15px;
        .move-file-container{
            padding:30px;
            display:flex;
            flex-direction:column;
            .move-file-title{
                color:#1a1a1a;
                font-size:24px;
                line-height:44px;
            }
            .move-file-desc{
                color:#333333;
                font-size:14px;
                line-height:44px;
                span{
                    background:#f3f4f6;
                    border-radius:10px;
                    font-size:12px;
                    padding:5px 8px;
                }
            }
            .folder-list{
                width:100%;
                height:490px;
                overflow-y:scroll;
                overflow-x:hidden;
                border:1px solid #e0e0e0;
                border-radius:5px;
                padding:10px;
                &::-webkit-scrollbar{
                    display:none;
                }
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            column-gap:10px;
            margin-bottom:30px;
            .btn{
                width:110px;
                height:32px;
                border-radius:6px;
                background:#ffffff;
                border:1px solid #dedee0;
                line-height:32px;
                text-align:center;
                cursor:pointer;
                color:#4d4d4d;
                font-size:14px;
                &:last-child{
                    color:#ffffff;
                    background:#ff5967;
                    border:none;
                }
            }
        }
    }
</style>